export const IOS_URL = 'https://apps.apple.com/us/app/nekochan-app/id6748387108';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.neko.chan&hl=es_US';

const isEs = (lang) => typeof lang === 'string' && lang.toLowerCase().startsWith('es');

// Apple's official badge generator (returns SVG, locale-aware).
// Locale segment is ISO; en-us / es-mx both supported.
export function appStoreBadgeUrl(lang) {
  const locale = isEs(lang) ? 'es-mx' : 'en-us';
  return `https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/${locale}?size=250x83`;
}
export function appStoreBadgeAlt(lang) {
  return isEs(lang) ? 'Descargar en la App Store' : 'Download on the App Store';
}

// Google's official badge image, locale-aware.
export function googlePlayBadgeUrl(lang) {
  return isEs(lang)
    ? 'https://play.google.com/intl/es-419/badges/static/images/badges/es-419_badge_web_generic.png'
    : 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
}
export function googlePlayBadgeAlt(lang) {
  return isEs(lang) ? 'Disponible en Google Play' : 'Get it on Google Play';
}

// Google Play's official PNG has ~25% vertical padding baked in.
// Setting height: 58 on Play vs height: 40 on App Store makes both
// appear visually the same height to the human eye.
export const APP_STORE_BADGE_STYLE = { height: 40, width: 'auto', display: 'block' };
export const GOOGLE_PLAY_BADGE_STYLE = { height: 58, width: 'auto', display: 'block' };
